import React from "react";
import ScreenRotationIcon from "@mui/icons-material/ScreenRotation";
import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet-async";

import logoIcon from "../../../media/svg/logo-slim-icon.svg";
import UseWindowDimensions from "../../../utils/windowSize";
import { isMobile } from "react-device-detect";
import useDetectKeyboardOpen from "use-detect-keyboard-open";

const RotateScreen = () => {
  const { width, height } = UseWindowDimensions();
  const isKeyboardOpen = useDetectKeyboardOpen();

  return (
    <>
      {width > height && isMobile && !isKeyboardOpen ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            zIndex: 9999,
            position: "fixed",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "white.main",
            top: 0,
            bottom: 0,
            right: 0,
            left: 0,
            color: "gray.main",
          }}
        >
          <Helmet>
            <link rel='stylesheet' href='/app-width.css' />
          </Helmet>
          <ScreenRotationIcon sx={{ fontSize: "55px", mb: "20px" }} />
          <Typography sx={{ fontSize: "24px", mb: "40px", color: "gray.main" }}>
            Please Rotate your phone.
          </Typography>
          <img src={logoIcon} alt='Azad Logo Icon' width='60px' height='60px' />
        </Box>
      ) : null}
    </>
  );
};

export default RotateScreen;
